export default __webpack_public_path__ + "chevron-sign-left.png";